import { useRef, useEffect } from 'react';

// src/utils/create-update-effect.ts
var createUpdateEffect = (
  /**
   * Builds an effect hook that skips the first run and only calls the effect on later updates.
   *
   * @param hook - The base effect hook (useEffect or useLayoutEffect) to wrap.
   * @param effect - The effect callback to run on updates.
   * @param deps - Dependencies that trigger the effect when they change.
   * @returns An effect hook with the same signature that ignores the initial mount.
   */
  (hook) => (effect, deps) => {
    const isMounted = useRef(false);
    hook(
      () => () => {
        isMounted.current = false;
      },
      []
    );
    hook(() => {
      if (isMounted.current) {
        return effect();
      }
      isMounted.current = true;
    }, deps);
  }
);
var create_update_effect_default = createUpdateEffect;
var use_update_effect_default = createUpdateEffect(useEffect);

export { createUpdateEffect, create_update_effect_default, use_update_effect_default };
